module.exports = __webpack_public_path__ + "img/benoit18.52962dc6.jpg";